import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { Customer, CustomerProps } from 'types/customer';
const initialState: CustomerProps = {
    isOpen: false,
    isCustomerOpen: false,
    open: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    isLoading:false,
    total:0,
    list: [],
    customer: null,
    error: null,
    alertPopup: false
  };
const customer = createSlice({
    name: 'customer',
    initialState,
    reducers: {
      // review project popup
     
      // is customer open
      customerPopup(state, action) {
        state.isCustomerOpen = action.payload.isCustomerOpen;
      },
  
      // handler customer form popup
      toggleCustomerPopup(state, action) {
        state.open = action.payload.open;
      },
  
      // handler customer form popup
     
  
      hasError(state, action) {
        state.error = action.payload.error;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get all project list
      getList(state, action) {
        state.list.push(action.payload);
        const replaceList = state.list.filter((liste) => liste.id != 0);
        state.list = replaceList;
      },
  
      // get project details
      SetCustomer(state, action) {
        state.customer = action.payload;
      },
  
      // GET Customers
      setCustomersSuccess(state, action) {
          state.list = action.payload.data;
          state.current_page=action.payload.current_page;
          state.last_page=action.payload.last_page;
          state.total=action.payload.total
      },

    // ADD Customer
    addCustomerSuccess(state, action) {
      state.list = [...state.list,action.payload];      
    },

    // EDIT Customer
    editCustomerSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
    },

    deleteCustomerSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
    }

    }
  });
  export default customer.reducer;
  export const {  customerPopup, toggleCustomerPopup,  getList,setPageNumber,setPageLimit, } = customer.actions;

  export function getCustomers(params:any={}) {
    return async () => {
      try {
        const response = await axios.get('customer',{params:params});
        dispatch(customer.actions.setCustomersSuccess(response.data));
      } catch (error) {
        dispatch(customer.actions.hasError(error));
      }
    };
  }

  export function getCustomer(id: string | undefined) {
    return async () => {
      try {
        const response = await axios.post('/api/product/details', { id });
        dispatch(customer.actions.SetCustomer(response.data));
      } catch (error) {
        dispatch(customer.actions.hasError(error));
      }
    };
  }

  export function addCustomer(cust:any) {
    return async () => {
      try {
        console.log(axios.defaults.baseURL);
        console.log(cust);
        
        const response = await axios.post('customer', cust);
        console.log(response.status);
        dispatch(customer.actions.addCustomerSuccess(response.data));
      } catch (error) {
        dispatch(customer.actions.hasError(error));
      }
    };
  }
  
  export function editCustomer(id: number | undefined,cust: Customer) {
    return async () => {
      try {
        const response = await axios.put('/customer/'+id, cust);
        dispatch(customer.actions.editCustomerSuccess(response.data));
      } catch (error) {
        dispatch(customer.actions.hasError(error));
      }
    };
  }

  export function deleteCustomer(id: number | undefined) {
    return async () => {
      try {
        await axios.delete('/customer/'+id);
        dispatch(customer.actions.deleteCustomerSuccess(id));
      } catch (error) {
        dispatch(customer.actions.hasError(error));
      }
    };
  }